import { get, post, put } from '@/utils/request';

export interface LoginCredentials {
  username: string;
  password: string;
}

// 登录接口在服务端校验并消费一次性、绑定 IP 的 loginTicket。
export const userLogin = async (
  data: LoginCredentials & { loginTicket: string },
) => {
  return await post(`/api/login/user`, { data });
  // return await post(`/api/login/admin`, { data });
};

// 普通用户登录成功后，同步本次登录的 token。
export const updateToken = async (token: string) => {
  return await put('/api/v1/pay/updateToken', {
    headers: { token },
    skipErrorHandler: true,
  });
};

/**
 * @description 获取登录用户信息
 */
export const getUserInfo = async () => {
  return await get(`/api/user/getUserInfo`, {});
};

/**
 * @description 创建用户谷歌验证Secret 返回url做成图片
 */
export const createGoogleAuthKey = async () => {
  return await get(`/api/login/createGoogleAuthKey`, {});
};

/**
 * @description 验证谷歌验证码
 * @param code 验证码（6位）
 * @param userId 用户ID
 * @param isLogin 是否登录调用
 */
export const validateGoogleAuth = async (
  code: number,
  userId: number,
  isLogin: boolean,
) => {
  return await get('/api/login/validateGoogleAuth', {
    params: {
      code,
      userId,
      isLogin,
    },
  });
};
